// extracted by mini-css-extract-plugin
export default {"form":"Form_form__xjzBH","textInput":"Form_textInput__bTlWy","reset_btn":"Form_reset_btn__cloV3"};